import { render, staticRenderFns } from "./miohistoryedata.vue?vue&type=template&id=52a0cd82&scoped=true&"
import script from "./miohistoryedata.vue?vue&type=script&lang=ts&"
export * from "./miohistoryedata.vue?vue&type=script&lang=ts&"
import style0 from "./miohistoryedata.vue?vue&type=style&index=0&id=52a0cd82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a0cd82",
  null
  
)

export default component.exports